import React from 'react';
import { Heading, PropertyGroup } from '../../components';
import { languagesHelper as language } from '../../util/languages';
import { useIntl } from '../../util/reactIntl';

import css from './ProfilePage.module.css';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true, id } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  const intl = useIntl();

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {language.labelsTranslator(id, intl)}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
        useTranslations
      />
    </div>
  );
};

export default SectionMultiEnumMaybe;
